var _style, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".spinner_hzlK{animation:spinner_vc4H .8s linear infinite;animation-delay:-.8s}.spinner_koGT{animation-delay:-.65s}.spinner_YF1u{animation-delay:-.5s}@keyframes spinner_vc4H{0%{y:1px;height:22px}93.75%{y:5px;height:14px;opacity:.2}}")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "spinner_hzlK",
    x: 1,
    y: 1,
    width: 6,
    height: 22
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "spinner_hzlK spinner_koGT",
    x: 9,
    y: 1,
    width: 6,
    height: 22
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "spinner_hzlK spinner_YF1u",
    x: 17,
    y: 1,
    width: 6,
    height: 22
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.1c5155bee406587bda699c01b2c3b6f3.svg";
export { ForwardRef as ReactComponent };